/**
 * Print job roles — map workload → device assignment (not brand detection).
 * Each role has a preferred Electron silent-print kind.
 */

export const PRINT_ROLE = Object.freeze({
  RECEIPT: 'receipt',
  DOCUMENT: 'document',
  LABEL: 'label'
});

export const PRINT_ROLE_IDS = Object.freeze([
  PRINT_ROLE.RECEIPT,
  PRINT_ROLE.DOCUMENT,
  PRINT_ROLE.LABEL
]);

/** @type {Record<string, { kind: 'thermal'|'document'|'label-sheet', paperHint: string }>} */
export const PRINT_ROLE_META = Object.freeze({
  [PRINT_ROLE.RECEIPT]: { kind: 'thermal', paperHint: '58/80mm' },
  [PRINT_ROLE.DOCUMENT]: { kind: 'document', paperHint: 'A4/A5' },
  [PRINT_ROLE.LABEL]: { kind: 'label-sheet', paperHint: 'étiquette' }
});

export function isPrintRole(value) {
  return PRINT_ROLE_IDS.includes(String(value || ''));
}

export function normalizePrintRole(value, fallback = PRINT_ROLE.RECEIPT) {
  const raw = String(value || '').trim().toLowerCase();
  return isPrintRole(raw) ? raw : fallback;
}

/**
 * Map silent-print kind → role (for resolve without explicit role).
 * @param {string} [kind]
 */
export function printKindToRole(kind) {
  const k = String(kind || '').trim().toLowerCase();
  if (k === 'document') return PRINT_ROLE.DOCUMENT;
  if (k === 'label-sheet' || k === 'label') return PRINT_ROLE.LABEL;
  return PRINT_ROLE.RECEIPT;
}

/**
 * @param {string} role
 * @returns {'thermal'|'document'|'label-sheet'}
 */
export function roleToPrintKind(role) {
  const id = normalizePrintRole(role);
  return PRINT_ROLE_META[id]?.kind || 'thermal';
}

/**
 * Whether an unassigned role may silently use the receipt queue.
 * Default false: documents/labels must not land on thermal POS paper.
 * Opt-in only via resolveAssignedDeviceNameForRole({ allowLegacyReceiptFallback: true }).
 *
 * @param {string} [role]
 * @returns {boolean}
 */
export function roleAllowsReceiptFallback(role) {
  void role;
  return false;
}
